module.exports = __webpack_public_path__ + "media/icons/pdf_placeholder-96250797.svg";